import {Component} from '@angular/core';

@Component({
  selector: 'district-modules',
  template: '<router-outlet></router-outlet>'
})
export class DistrictModulesComponent {
}
